
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.923 12.382a1 1 0 00-.217-1.09L12.711.293A1 1 0 0011.3 1.707L20.586 11H1a1 1 0 000 2h19.586L11.3 22.293a1 1 0 101.414 1.414l11-11a1 1 0 00.209-.325z"}})])
          )
        }
      }
    